export { default as GlobalCompanyTabsDropdown } from './GlobalCompanyTabsDropdown';
